export class Constants {
    public static ROLES = {
      SUPER_ADMIN: { id: 1, name: "Super Admin" },
      ADMIN: { id: 2, name: "Admin" },
    };
  }